import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import { Slide } from "react-slideshow-image"
import "react-slideshow-image/dist/styles.css"

import * as highlightsStyles from "../../styles/world_championships/Highlights.module.css"

const Highlights = props => {
  const { content } = props

  const subtitle = ChildSelector.select(
    content,
    `subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const picturesList = ChildSelector.select(
    content,
    `highlights-pictures`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )
  const pictures =
    (picturesList &&
      picturesList.childNodes.map((pic, idx) => {
        return { childNodes: [pic] }
      })) ||
    []

  return (
    <div className="container-fluid">
      <div className={`row ${highlightsStyles.wrapper}`}>
        <div className={`col-12`}>
          <div className={`row g-0`}>
            <div className={`col-12 ${highlightsStyles.heading}`}>
              <h4>{title}</h4>
              <h2>{subtitle}</h2>
            </div>
          </div>

          <div className={`row g-0`}>
            <div className={`col-12 ${highlightsStyles.content}`}>
              <Slide
                easing="cubic"
                cssClass={highlightsStyles.sliderWrapper}
                autoplay={true}
                infinite={true}
                slidesToScroll={2}
                slidesToShow={2}
                indicators={true}
              >
                <a
                  href="https://www.youtube.com/watch?v=E51Zag-cPCo&list=PLSKJHVkaW8CbX1BRYcqv_HyNpPyZ2qIMb&index=3&t=30s"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://img.youtube.com/vi/E51Zag-cPCo/hqdefault.jpg"
                    alt="IBM TM1 Anwendertag & The TM1 World Championship 2023 - Ehningen"
                  />
                </a>

                <a
                  href="https://www.youtube.com/watch?v=VRs_NdEyzAY&list=PLSKJHVkaW8CbX1BRYcqv_HyNpPyZ2qIMb&index=1&t=45s"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://img.youtube.com/vi/VRs_NdEyzAY/hqdefault.jpg"
                    alt="The life of the first TM1 World Champion"
                  />
                </a>

                <a
                  href="https://www.youtube.com/watch?v=b6qIA5PUX6o&list=PLSKJHVkaW8CbX1BRYcqv_HyNpPyZ2qIMb&index=2&t=371s"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://img.youtube.com/vi/b6qIA5PUX6o/hqdefault.jpg"
                    alt="15 Minutes of TM1 with.. Cristian Blana"
                  />
                </a>

                <a
                  href="https://www.youtube.com/watch?v=5HseE39JG6Y&list=PLSKJHVkaW8CZCSbH15NYTRx9rfjr3xGO9&index=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://img.youtube.com/vi/5HseE39JG6Y/hqdefault.jpg"
                    alt="15 minutes of TM1 with... Dwight Smith - The TM1 World Champion"
                  />
                </a>

                {pictures.map((pic, idx) => (
                  <WPImage
                    key={idx}
                    holder={pic}
                    selector={`wp-block-image`}
                    mode={DISPLAY_MODE.normal}
                    className={`${highlightsStyles.highlightImage}`}
                  />
                ))}
              </Slide>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Highlights
